module.exports = __webpack_public_path__ + "prod/1.42.2/img/xueersi-icon.03fefdcd.png";